import React from "react";

export function DetailRow({ label, value }) {
    return (
        <div className="flex items-start py-1 text-xs gap-2">
            <span className="text-gray-900 font-bold w-[140px] flex-shrink-0">{label}</span>
            <span className="text-gray-500 font-medium flex-1 text-left">{value}</span>
        </div>
    );
}

export const formatVal = (val) => {
    if (val === "" || val === null || val === undefined) {
        return "-";
    }
    return val;
};

export const renderSlotDetails = (slot) => {
    if (!slot) return "-";
    if (typeof slot === "string") return formatVal(slot);
    if (typeof slot === "object") {
        const parts = [];
        if (slot.slot_date) parts.push(slot.slot_date);
        if (slot.slot_time) parts.push(slot.slot_time);
        if (parts.length === 0) return "-";
        return parts.map(formatVal).join(" ");
    }
    return "-";
};
